import { createAction, createSlice } from '@reduxjs/toolkit';
import { CoreMsgTypes } from '@tassat/payments-definitions';

export interface KillSwitchState {
    killSwitchOn: boolean;
}

const initialState: KillSwitchState = { killSwitchOn: false };

const initialLoadAction = createAction<{
    system?: {
        killSwitch: { EnableKillSwitch: boolean };
    };
}>('InitialLoad');
const systemKillSwitchAction = createAction<{ EnableKillSwitch: boolean }>(CoreMsgTypes.SystemKillSwitch);

const killSwitchSlice = createSlice({
    name: 'killSwitch',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initialLoadAction, (state, action) => {
                if (action.payload.system !== undefined) {
                    state.killSwitchOn = action.payload.system.killSwitch.EnableKillSwitch;
                }
            })
            .addCase(systemKillSwitchAction, (state, action) => {
                state.killSwitchOn = action.payload.EnableKillSwitch;
            });
    }
});

export default killSwitchSlice.reducer;